import React from "react";

function TimeOffComponent() {
  return <div>TimeOffComponent</div>;
}

export default TimeOffComponent;
